module.exports = __webpack_public_path__ + "img/img56.0aa77f07.png";